import type { FC } from "react";
import UspItem from "./components/UspItem/UspItem";
import * as s from "./UspList.module.scss";

type UspListProps = {
	usps: string[];
};

const UspList: FC<UspListProps> = ({ usps }) => {
	return (
		<ul className={s.list}>
			{usps.map((usp, index) => (
				<UspItem key={`${usp}-${index}`}>{usp}</UspItem>
			))}
		</ul>
	);
};

export default UspList;
